// this file is automatically generated by app-version-info.ts script at build time
/* tslint:disable */export const appVersionInfo = {
  version: '4.153.0',
  revision: 'interface-4.153-4-g97112689d',
  dateTime: 1789039588385,
  branch: 'HEAD'};